import React, { useRef, useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';

import './MainActivityMasjid.css'
import DesignMasjidFilter from '../design/design_masjid/DesignMasjidFilter';
import Footer from '../../../Footer';
import PengantarUmum from './PengantarUmum';
import SmoothScrollToTop from '../../../../interface/smooth_scroll_to_top/SmoothScrollToTop';
import SEO from '../../../../SEO/SEO';

function MainActivityMasjid() {

    /** navigation to from div clicked */
    const navigate = useNavigate();
    /** onClick={() => { navigate('/detail-project/fawn-house') }} */


    return (
        <>
            <div className="gallery-design fade" id='id-gallery-design'>

                <SEO
                    title="Galeri Desain Masjid Gratis - Jasa Desain Masjid oleh Rekanata"
                    description="Jelajahi galeri desain masjid gratis dari Rekanata Konstruksi. Dapatkan desain masjid berkualitas tinggi untuk komunitas, yayasan, dan pembangunan masjid baru tanpa biaya."
                    canonical="https://rekanata.com/free-design#id-gallery-design"
                    metaKeywords="desain masjid gratis, galeri desain masjid, jasa desain masjid, desain masjid berkualitas, portofolio desain masjid, desain masjid komunitas, desain masjid yayasan, pembangunan masjid, jasa desain masjid online"
                // Tidak perlu menambahkan metaKeywords di sini. Jika tidak diisi, fallback default akan digunakan. 
                // Jika Anda mengisi nilai di sini, maka nilai yang dituliskan di properti ini yang akan digunakan.
                />


                <div className="gallery-design-hero-image">
                    <div className="gallery-design-hero-text">
                        <h1 className='gallery-design-h1'>FREE DESIGN MASJID</h1>
                    </div>
                </div>

                <PengantarUmum />

                {/** Include filter project gallery design */}
                <DesignMasjidFilter />

            </div>

            <Footer />
            <SmoothScrollToTop />

        </>
    )
}

export default MainActivityMasjid